export const getSlides = (
  items: any[],
  total: number,
  viewMoreEvent: string,
  disableViewMore?: boolean
) => {
  if (total <= items.length) return items
  const itemsLength = items.length
  const itemsPerSlide = 3
  const remainder = itemsLength % itemsPerSlide

  let itemsToRemove = 0
  if (remainder === 0) itemsToRemove = 1
  else if (remainder === 1) itemsToRemove = 2

  const adjustedArray = items.slice(0, itemsLength - itemsToRemove)
  if (disableViewMore) {
    return adjustedArray
  } else {
    return [...adjustedArray, { seeMoreSlide: true, event: viewMoreEvent }]
  }
}
